import invalidIcon from '../assets/invalid.svg';
import loadingAnim from '../assets/loading.gif';
import discord from '../assets/themes/ys-classic/discord.png';
import fbIcon from '../assets/themes/ys-classic/facebook.png';
import github from '../assets/themes/ys-classic/github.png';
import instaIcon from '../assets/themes/ys-classic/instagram.png';
import linkedin from '../assets/themes/ys-classic/linkedin.png';
import medium from '../assets/themes/ys-classic/medium.png';
import messenger from '../assets/themes/ys-classic/messenger.png';
import pinterest from '../assets/themes/ys-classic/pinterest.png';
import skype from '../assets/themes/ys-classic/skype.png';
import soundcloud from '../assets/themes/ys-classic/soundcloud.png';
import spotify from '../assets/themes/ys-classic/spotify.png';
import stackoverflow from '../assets/themes/ys-classic/stack-overflow.png';
import telegram from '../assets/themes/ys-classic/telegram.png';
import twitter from '../assets/themes/ys-classic/twitter.png';
import viber from '../assets/themes/ys-classic/viber.png';
import vk from '../assets/themes/ys-classic/vk.png';
import web from '../assets/themes/ys-classic/web.png';
import wechat from '../assets/themes/ys-classic/wechat.png';
import whatsapp from '../assets/themes/ys-classic/whatsapp.png';
import youtube from '../assets/themes/ys-classic/youtube.png';
import tick from '../assets/tick.svg';

export const PROVIDERS = {
	facebook: {
		name: 'facebook',
		domain: 'https://facebook.com/',
		icon: fbIcon,
	},
	instagram: {
		name: 'instagram',
		domain: 'https://instagram.com/',
		icon: instaIcon,
	},
	twitter: {
		name: 'twitter',
		domain: 'https://twitter.com/',
		icon: twitter,
	},
	linkedin: {
		name: 'linkedin',
		domain: 'https://linkedin.com/in/',
		icon: linkedin,
	},
	youtube: {
		name: 'youtube',
		domain: 'https://youtube.com/c/',
		icon: youtube,
	},
	website: {
		name: 'website',
		domain: 'https://',
		icon: web,
	},
	discord: {
		name: 'discord',
		domain: 'https://discord.com/',
		icon: discord,
	},
	github: {
		name: 'github',
		domain: 'https://github.com/',
		icon: github,
	},
	medium: {
		name: 'medium',
		domain: 'https://medium.com/',
		icon: medium,
	},
	messenger: {
		name: 'messenger',
		domain: 'https://messenger.com/',
		icon: messenger,
	},
	pinterest: {
		name: 'pinterest',
		domain: 'https://pinterest.com/',
		icon: pinterest,
	},
	skype: {
		name: 'skype',
		domain: 'https://skype.com/',
		icon: skype,
	},
	soundcloud: {
		name: 'soundcloud',
		domain: 'https://soundcloud.com/',
		icon: soundcloud,
	},
	spotify: {
		name: 'spotify',
		domain: 'https://spotify.com/',
		icon: spotify,
	},
	stackoverflow: {
		name: 'stackoverflow',
		domain: 'https://stackoverflow.com/',
		icon: stackoverflow,
	},
	telegram: {
		name: 'telegram',
		domain: 'https://telegram.com/',
		icon: telegram,
	},
	viber: {
		name: 'viber',
		domain: 'https://viber.com/',
		icon: viber,
	},
	vk: {
		name: 'vk',
		domain: 'https://vk.com/',
		icon: vk,
	},
	wechat: {
		name: 'wechat',
		domain: 'https://wechat.com/',
		icon: wechat,
	},
	whatsapp: {
		name: 'whatsapp',
		domain: 'https://whatsapp.com/',
		icon: whatsapp,
	},
};

export const INDICATE = {
	nil: {
		id: 'nil',
		icon: null,
	},
	loading: {
		id: 'loading',
		icon: loadingAnim,
	},
	valid: {
		id: 'valid',
		icon: tick,
	},
	invalid: {
		id: 'invalid',
		icon: invalidIcon,
	},
};
